































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import TariffListBase from "./TariffListBase";

	@Component
	export default class tariffList extends TariffListBase {
		created() {
            super.initializeRights('ACC_Tariff_Update', 'ACC_Tariff_Update', 'ACC_Tariff_Update', 'ACC_Tariff_Update');
            super.setDetailName('TariffDetail');
			super.created();
		
		}

		selectRows(items: any) {
			super.selectRows(items);
		}

        isSuperUserAllow(){
			return this.isSuperUser;
        }

	
		showAllertToDeleteClick(itemsSelected: any) {
			this.showAlertBeforeDeleteBase(itemsSelected);
		}


		loadFilters(value: any) { super.loadFilters(value); }
		createNewClick(elementId: any) { super.createNewClick(elementId); }
		detailClick(elementId: any) { super.detailClick(elementId); }
		deleteClick(elementId: any) { this.deleteClick(elementId) }
	};
